import styled from "styled-components";
import colors from "../../assets/styles/colors";

export const SliderInput = styled.input`
  margin-top: 37px;
  /*-webkit-appearance: none;
  width: 100%;
  height: 4px;
  background: #C1C9D2;
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
  

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    cursor: pointer;
    background: #FFFFFF;
    border: 1px solid rgba(193, 201, 210, 1);
    background-size: 45%;
    background-position: center;
    background-repeat: no-repeat;
  }

  &::-webkit-slider-runnable-track {
   background: red;
   height: 4px;
 }*/

`;

export const SliderContainer = styled.div`

  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const SliderLabel = styled.p`
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.03em;
  text-align: left;
  color: #2A2C31;

`;

export const SliderInputReadOnly = styled.input`
`;

export const SliderContainerLabelInput = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0px;
  max-height: 20px;
`;

export const SliderLabelMinMax = styled.p`
  color: ${colors.textPrimary};
  font-family: Inter;
  font-size: 18px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: right;
`;

export const SliderInputContainer = styled.div`
  
`;

